import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=37706fea&scoped=true&"
import script from "./RegisterPassword.vue?vue&type=script&lang=js&"
export * from "./RegisterPassword.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPassword.vue?vue&type=style&index=0&id=37706fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37706fea",
  null
  
)

export default component.exports